import { Money } from '@dreryk/money-common-api';

import { createVisitor } from '~libs.typescript';

type AdvancePaymentFlowData = {
   refundToBeCreatedAmount?: Money;
   remainingAmount: Money;
};

export const advancePaymentFlowVisitor = createVisitor<
   AdvancePaymentFlowData | null,
   { visitSettlement: void; visitSummary: void }
>((data, visitors) => {
   if (!data) {
      return visitors.visitSettlement?.();
   }

   const refundToBeCreatedAmount = data.refundToBeCreatedAmount?.asNumber() ?? 0;
   const remainingAmount = data.remainingAmount.asNumber();

   if (remainingAmount === 0 && refundToBeCreatedAmount === 0) {
      return visitors.visitSummary?.();
   }

   return visitors.visitSettlement?.();
});
